var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-banner",class:_vm.extraItem.extras('banner.bannerType'),style:({
    display: _vm.extraItem.extras('banner.display') == 1 ? 'block' : 'none',
  })},[(!_vm.extraItem.extras('banner.bannerType') || _vm.extraItem.extras('banner.bannerType')=='wide')?_c('img',{attrs:{"src":_vm.extraItem.extras('banner.src')
        ? _vm.extraItem.extras('banner.src')
        : '',"alt":""}}):_vm._e(),(_vm.extraItem.extras('banner.bannerType')=='narrow')?_c('img',{attrs:{"src":_vm.extraItem.extras('banner.img')
        ? _vm.extraItem.extras('banner.img')
        : '',"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }